"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrendingAPI = void 0;
const base_1 = require("../base");
class TrendingAPI extends base_1.BaseAPI {
    /**
     * Get the daily or weekly trending movies. The daily trending list tracks
     * items over the period of a day while items have a 24 hour half life.
     * The weekly list tracks items over a 7 day period, with a 7 day half life.
     *
     * @see https://developers.themoviedb.org/3/trending/get-trending
     */
    async getTrending(mediaType, timeWindow) {
        const path = this.getPath(`/trending/${mediaType}/${timeWindow}`);
        return this.get(path);
    }
}
exports.TrendingAPI = TrendingAPI;
